import {DriverContactFormVehicleModelEnum} from '@/services/api-clients';


export function driverContactFormVehicleModelNameFilter(model: DriverContactFormVehicleModelEnum): string {
  switch(model) {
    case DriverContactFormVehicleModelEnum.ToyotaCorolla2018: return 'Toyota Corolla 2018';
    case DriverContactFormVehicleModelEnum.ToyotaYarisCross2023: return 'Toyota Yaris Cross 2023';
    case DriverContactFormVehicleModelEnum.ToyotaYaris2022: return 'Toyota Yaris 2022';
    case DriverContactFormVehicleModelEnum.SkodaFabia2018: return 'Skoda Fabia 2018';
    case DriverContactFormVehicleModelEnum.DaciaLodgy2016: return 'Dacia Lodgy 2016';
    case DriverContactFormVehicleModelEnum.FordFocus2018: return 'Ford Focus 2018';
    case DriverContactFormVehicleModelEnum.KiaRio2018: return 'Kia Rio 2018';
    case DriverContactFormVehicleModelEnum.ToyotaAygo2021: return 'Toyota Aygo 2021';
    case DriverContactFormVehicleModelEnum.ToyotaCHR: return 'Toyota C-HR';
    case DriverContactFormVehicleModelEnum.MtbBike: return 'Rower Mtb';
    case DriverContactFormVehicleModelEnum.Mtb6080: return 'Rower Mtb, zasięg 60-80km';
    case DriverContactFormVehicleModelEnum.Mtb100120: return 'Rower Mtb, zasięg 100-120km';
    case DriverContactFormVehicleModelEnum.CityBike: return 'Rower Miejski';
    case DriverContactFormVehicleModelEnum.City6080: return 'Rower Miejski, zasięg 60-80km';
    case DriverContactFormVehicleModelEnum.City100120: return 'Rower Miejski, zasięg 100-120km';
    case DriverContactFormVehicleModelEnum.CommonBike: return 'Rower zwykły';
    case DriverContactFormVehicleModelEnum.Scooter: return 'Skuter';
    default: return '';
  }
}
